import { State } from './models';

export const countryAbbreviations = (state): State.IState => state.get('countryAbbreviations');
